import { DocumentLocation } from '../types';

export default [
  [DocumentLocation.Feed, DocumentLocation.Later, DocumentLocation.Shortlist, DocumentLocation.Archive],
  [DocumentLocation.Feed, DocumentLocation.New, DocumentLocation.Later, DocumentLocation.Archive],
  [DocumentLocation.Feed, DocumentLocation.Later, DocumentLocation.Archive],
];
